import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GetService {
  /**
   * Retrieves a value from an object using a path string or array
   * @param object The object to retrieve the value from
   * @param path The path string or array to retrieve the value from
   * @param defaultValue The default value to return if the path is not found
   * @returns The value at the specified path or the default value if the path is not found
   */
  static get<T>(object: any, path: string | string[], defaultValue?: any): T {
    const parsePath = (path: string | string[]): string[] => {
      if (Array.isArray(path)) {
        return path;
      }
      // Handle bracket notation like 'a[0].b.c'
      return path.replace(/\[(\w+)\]/g, '.$1').split('.');
    };

    const segments = parsePath(path);
    let result = object;

    for (const segment of segments) {
      if (result == null) {
        // handles both null and undefined
        return defaultValue as T;
      }
      result = result[segment];
    }

    return (result === undefined ? defaultValue : result) as T;
  }
}
